import React, { useEffect, useState } from "react";

import { useForm } from "../useForm";

import NewPackageDetails1 from "./newComponents/NewPackageDetails1";
import NewPackageDetails2 from "./newComponents/NewPackageDetails2";
import ModelErrorComponent from "../../modals/ModelErrorComponent";
import ReceivedMaterialsForPackaging from "./newComponents/ReceivedMaterialsForPackaging";
import ListOfBrandsTable from "./newComponents/ListOfBrandsTable";
import WeightScalePad from "../../controls/WeightScalePad";
import WeightScale from "../../controls/WeightScale";
import ButtonSpinner from "../../controls/ButtonSpinner";
import PrintProgressModal from "./PrintProgressModal";
import { convertToTwoDecimals } from "../../../shared/utility";

import { io } from "socket.io-client";

const initialFValues = {
  product_id: -1,
  production_product_id: -1,
  packaging_date: new Date(),
  production_date: "",
  best_before_date: "",
  shelf_life: "",
  serial_number: "",
  supervisor: [],
  employee_1: [],
  employee_2: [],
  room_temperature: "",
  product_temperature: "",
  barcode: "",
  description_en: "",
  plu: "",
  product_name: "",
  production_run_plu: "",
  production_run_product_name: "",
  packaging_material_1: "",
  packaging_material_2: "",
  number_of_label_to_print: 1,
  brand_id: -1,
  brand_name: null,
  is_default_brand: false,
  is_create_pallet: false,
  passed_from_metal_detector: true,
  lot_number: "",
  is_scale: false,
};

export default function NewPackageForm(props) {
  const {
    employeeOptions,
    isEdit,
    getManufacturedItemByLot,
    packagedProduct,
    setEmptyModelOpen,
    setSlideOver,
    savePackagingDetailsAndPrint,
    brands,
    showErrorModal,
    setScaleIsOpen,
    scaleIsOpen,
    printedPackageItems,
    deleteSinglePackagedItem,
    reprintPackageLabel,
    fetchProductByPlu,
    printProgress,
    getInContactPackagingSupplies,
    reprintInProgress,
    deleteInProgress,
    supervisorOptions,
    lotNumbers,
    onSearchLotNumbers,
  } = props;

  const [barcodeScanInProgress, setBarcodeScanInProgress] = useState(false);
  const defaultScaleData = {
    grossWeight: 0.0,
    packing_size: 0.0,
    bgStable: false,
    isLbs: false,
    typeName: "kg",
  };
  const [scaleData, setScaleData] = useState(defaultScaleData);
  const [showNumberPad, setShowNumberPad] = useState({
    show: false,
    name: null,
  });
  const [showWeightScalePad, setShowWeightScalePad] = useState({
    show: false,
    name: null,
  });
  const [tare, setTare] = useState(0);

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    temp.production_product_id = null;
    if (values.production_product_id < 1) {
      temp.production_product_id = "Please enter lot number";
      showErrorModal("Please enter lot number");
    }

    temp.packaging_date = null;
    if (values.packaging_date === "") {
      temp.packaging_date = "Please select a date.";
    }

    temp.supervisor = null;
    if (values.supervisor.length < 1) {
      temp.supervisor = "Please select a supervisor.";
    }

    temp.brand_id = null;
    if (values.brand_id < 1) {
      temp.brand_id = "Please choose a brand.";
      showErrorModal("Please select a brand");
    }

    temp.number_of_label_to_print = null;
    if (
      values.number_of_label_to_print === "" ||
      parseInt(values.number_of_label_to_print) < 1
    ) {
      temp.number_of_label_to_print = "Please select a number more than 0.";
    }

    temp.room_temperature = null;
    if (
      values.room_temperature === "" ||
      values.room_temperature == null ||
      String(values.room_temperature).trim() === ""
    ) {
      temp.room_temperature = "Please enter room temperature.";
    }

    temp.product_temperature = null;
    if (
      values.product_temperature === "" ||
      values.product_temperature == null ||
      String(values.product_temperature).trim() === ""
    ) {
      temp.product_temperature = "Please enter product temperature.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate,
  );

  const onLotNumberSelected = async function (scannedBarcode) {
    if (scannedBarcode || scannedBarcode !== "") {
      setBarcodeScanInProgress(true);

      const fetchedItem = await getManufacturedItemByLot(scannedBarcode);

      if (fetchedItem) {
        const isFreeWeight = !parseFloat(fetchedItem.data.packing_size) > 0.0;
        setValues({
          ...values,
          production_product_id: fetchedItem.data.id,
          user_id: fetchedItem.data.user_id,
          product_id: fetchedItem.data.product_id,
          production_date: fetchedItem.data.production_date,
          best_before_date: fetchedItem.data.shelf_life_date,
          is_free_weight: isFreeWeight,
          packing_size: fetchedItem.data.packing_size,
          shelf_life: fetchedItem.data.shelf_life,
          description_en: fetchedItem.data.description_en,
          product_barcode: fetchedItem.data.product_barcode,
          brand: fetchedItem.data.brand,
          plu: fetchedItem.data.plu,
          product_name: fetchedItem.data.product_name,
          production_run_plu: fetchedItem.data.plu,
          production_run_product_name: fetchedItem.data.product_name,
          lot_number: fetchedItem.data.lot_number,
          export_eligible: fetchedItem.data.export_eligible,
          number_of_label_to_print: isFreeWeight
            ? 1
            : values.number_of_label_to_print,
        });
        setScaleData({
          ...defaultScaleData,
          packing_size: fetchedItem.data.packing_size,
        });
      } else {
        setEmptyModelOpen({
          childComponent: (
            <ModelErrorComponent
              setOpen={setEmptyModelOpen}
              subtitle="We could not find that product!"
              title="Error"
            />
          ),
          open: true,
        });
      }

      setBarcodeScanInProgress(false);
    }
  };

  const openPackagingOptions = (item_name) => {
    setSlideOver({
      childComponent: (
        <ReceivedMaterialsForPackaging
          getInContactPackagingSupplies={getInContactPackagingSupplies}
          setOpen={setSlideOver}
          setItemValues={(packagingItem) => {
            var packagingObj = null;
            if (item_name === "packaging_material_1") {
              packagingObj = { packaging_material_1: packagingItem };
            } else if (item_name === "packaging_material_2") {
              packagingObj = { packaging_material_2: packagingItem };
            } else if (item_name === "packaging_material_3") {
              packagingObj = { packaging_material_3: packagingItem };
            }

            setValues({
              ...values,
              ...packagingObj,
            });
          }}
        />
      ),
      open: true,
    });
  };

  const handleSavePackageAndPrint = async function (extraPayload = {}) {
    if (validate()) {
      await savePackagingDetailsAndPrint({
        ...values,
        is_scale: scaleIsOpen,
        packing_size: scaleData.packing_size,
        ...extraPayload,
      });
    }
  };

  const showBrands = () => {
    setSlideOver({
      childComponent: (
        <ListOfBrandsTable
          brands={brands}
          setItemValues={(brand_id, brand_name) => {
            setValues({
              ...values,
              brand_id: brand_id,
              brand_name: brand_name,
            });
            setSlideOver({
              open: false,
              childComponent: null,
            });
          }}
        />
      ),
      open: true,
      size: "max-w-xl",
    });
  };

  useEffect(() => {
    brands.data.forEach((brand) => {
      if (brand.is_default_brand === 1) {
        setValues({
          ...values,
          brand_id: brand.id,
          brand_name: brand.name,
          is_default_brand: brand.is_default_brand === 1,
        });
      }
    });
  }, [brands]);

  function handleIncomingScaleData(data) {
    var newWeight = "";

    const rawWeight = data.weight;
    const trimmedValue = rawWeight.substring(rawWeight.lastIndexOf(" ") + 1);

    // this is for seeing if kg scale is stable
    var isKgStable = trimmedValue.charAt(trimmedValue.length - 1) != "M";
    // LG stuff is for weighing by lb
    var isLGM =
      trimmedValue.substring(trimmedValue.length - 3, trimmedValue.length) ==
      "LGM";
    var isLG =
      trimmedValue.substring(trimmedValue.length - 2, trimmedValue.length) ==
      "LG";

    var isLbs = true;
    var isBgStable = false;
    var typeName = "lbs";
    var newTareWeight = tare;
    if (trimmedValue.length > 0) {
      var amountToSubtract = isKgStable ? 0 : 1;
      if (isLGM) {
        newWeight = trimmedValue.substring(0, trimmedValue.length - 3) + "LB";
      } else if (isLG) {
        newWeight = trimmedValue.substring(0, trimmedValue.length - 2) + "LB";
      } else {
        newWeight = trimmedValue.substring(
          0,
          trimmedValue.length - amountToSubtract,
        );

        isLbs = false;
        typeName = "kg";
      }
      isBgStable = isKgStable || isLG;

      if (values.isLbs != isLbs) {
        if (isLbs) {
          newTareWeight = newTareWeight * 2.205;
        } else {
          newTareWeight = newTareWeight / 2.205;
        }
        setTare(newTareWeight);
      }

      setScaleData({
        ...scaleData,
        packing_size: convertToTwoDecimals(
          parseFloat(newWeight) - newTareWeight,
        ),
        grossWeight: convertToTwoDecimals(
          parseFloat(newWeight + newTareWeight),
        ),
        bgStable: isBgStable,
        isLbs: isLbs,
        typeName: typeName,
      });
    }
  }

  useEffect(() => {
    if (scaleIsOpen) {
      const newSocket = io("http://localhost:5001");

      newSocket.on("scale_data", (data) => {
        handleIncomingScaleData(data, tare);
      });

      newSocket.on("error", (data) => {
        console.log("SOCKET_ERROR: ", data.error);
        // showErrorModal("SOCKET_ERROR: ", data.error);
      });

      newSocket.emit("start_listening", {});
      return () => newSocket.close();
    }
  }, [scaleIsOpen, tare]);

  return (
    <div className="px-4 sm:px-6 lg:px-4">
      <PrintProgressModal
        open={printProgress.loading}
        message={printProgress.message}
      />
      <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {values.brand_name
              ? `Packaging Product for ${values.brand_name}`
              : "Package new product, please select brand"}
          </h1>
        </div>
      </div>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <NewPackageDetails1
          employeeOptions={employeeOptions}
          supervisorOptions={supervisorOptions}
          errors={errors}
          isEdit={isEdit}
          onSearchLotNumbers={onSearchLotNumbers}
          onLotNumberSelected={onLotNumberSelected}
          handleInputChange={handleInputChange}
          packagedProduct={packagedProduct}
          values={values}
          openPackagingOptions={openPackagingOptions}
          handleSavePackageAndPrint={handleSavePackageAndPrint}
          showNumberPad={showNumberPad}
          setShowNumberPad={setShowNumberPad}
          showBrands={showBrands}
          barcodeScanInProgress={barcodeScanInProgress}
          setScaleIsOpen={setScaleIsOpen}
          scaleIsOpen={scaleIsOpen}
          showErrorModal={showErrorModal}
          printInProgress={printProgress.loading}
          lotNumbers={lotNumbers}
          setEmptyModelOpen={setEmptyModelOpen}
        />
        <NewPackageDetails2
          errors={errors}
          handleInputChange={handleInputChange}
          values={values}
          showNumberPad={showNumberPad}
          setShowNumberPad={setShowNumberPad}
          fetchProductByPlu={fetchProductByPlu}
          setValues={setValues}
          scaleData={scaleData}
          setScaleData={setScaleData}
        />
        <WeightScalePad
          showWeightScalePad={showWeightScalePad}
          setShowWeightScalePad={setShowWeightScalePad}
          values={values}
        />
        <div className="gap-2">
          {scaleIsOpen ? <WeightScale scaleData={scaleData} /> : null}
          {/* <div className="mt-5">
            <Numberpad
              showNumberPad={showNumberPad}
              setShowNumberPad={setShowNumberPad}
              values={values}
            />
          </div> */}
        </div>
      </div>
      <div className="mt-5">
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden card-custom">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-white">
                    <tr>
                      <th
                        scope="col"
                        className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        Serial Number
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        PLU
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Lot Number
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Description
                      </th>
                      <th
                        scope="col"
                        className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                      ></th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {printedPackageItems.length > 0 ? (
                      printedPackageItems.map((assemblyItem) => (
                        <tr key={assemblyItem.package_id}>
                          <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            {assemblyItem.serial_number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {assemblyItem.plu}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {assemblyItem.lot_number}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {assemblyItem.name}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {assemblyItem.description}
                          </td>
                          <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                            <button
                              onClick={() => {
                                reprintPackageLabel(assemblyItem);
                              }}
                              className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                              disabled={false} // reprintInProgress
                            >
                              <ButtonSpinner
                                spin={false} // reprintInProgress
                                text="Print again"
                              />
                            </button>
                            <button
                              onClick={() => {
                                deleteSinglePackagedItem(
                                  assemblyItem.package_id,
                                );
                              }}
                              className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                              disabled={deleteInProgress}
                            >
                              <ButtonSpinner
                                spin={deleteInProgress}
                                text="Delete"
                              />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="py-5 text-center">
                          Please start scanning products
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
